import React from 'react'
import {Helmet} from 'react-helmet'
import {useSelector} from 'react-redux'
import {stateManager} from './store'


const DocumentHead = () => {
  const pageTitle = useSelector(stateManager.getLayoutConfig__pageTitle)
  return <Helmet
    title= {pageTitle}
    defaultTitle="DFO  Warranty & Review"
  >
    <meta name="description" content="DFO  Warranty & Review application"/>
  </Helmet>
}

DocumentHead.propTypes = {}

export default DocumentHead




